import { render, staticRenderFns } from "./ApfSignaturePadModal.vue?vue&type=template&id=80ff4a1a"
import script from "./ApfSignaturePadModal.vue?vue&type=script&lang=js"
export * from "./ApfSignaturePadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports